import { createFileRoute } from '@tanstack/react-router'

import { CompanyActivity } from '@/activity/components/CompanyActivity/CompanyActivity'
import { CompanyPage } from '@/app/manager/CompanyPage/CompanyPage'
import { buildPageTitle } from '@/core/utils/buildPageTitle/buildPageTitle'

export const Route = createFileRoute('/company/_management/activities')({
  head: () => ({
    meta: [
      {
        title: buildPageTitle({
          titleKey: 'page-title-activity-log',
        }),
      },
    ],
  }),
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <CompanyPage>
      <CompanyActivity />
    </CompanyPage>
  )
}
